<template lang="pug">
  div.utilization-products-table
    div.col-block.utilization-products-table-title
      div.title
        p Наименование и количество конечного продукта
        e-button-add(
          @click="addRow()"
        )

    div(:class="{'is-invalid': getError}").products
      e-table-editable(
        ref="editTable"
        :attributes="attr"
        :dataUrl="dataEndpoint"
        :postUrl="() => null"
        :patchUrl="() => null"
        :deleteUrl="() => null"
        :tableInOnlineMode="false"
        :tableHeight="'180'"
        :tableHeightRight="'180'"
        :fewRowsCount="2"
      )

    div.invalid-relative-container
      transition(v-if="getError" name="fade")
        span( v-show="error").invalid.error {{error}}
</template>

<script>
  import {editableValidatorMixin} from "../../../components/table-editable/editable-validator-mixin";
  import {UNIT_OPTIONS} from '../../../config/config'

  export default {
    name: "utilization-products-table",
    mixins: [editableValidatorMixin],
    props: {
      tabView: null,
      dataUrl: {
        type: Function
      },
      model: {
        type: Object
      }
    },
    computed: {
      dataEndpoint () {
        return this.dataUrl()
      },
      attr () {
        return {
          name: {
            label: "Наименование",
            placeholder: ' ',
            validationRulePattern: '(\\.*)',
            width: 80
          },
          unit: {
            label: "Ед.измерения",
            placeholder: ' ',
            width: 80,
            select: {
              options: UNIT_OPTIONS
            },
            transform: (model) => (
                UNIT_OPTIONS.find(o => o.id == model.unit) || {}
              ).name
          },
          count: {
            label: "Количество",
            width: 80
          }
        }
      }
    },
    methods: {
      getTableRef () {
        return this.$refs.editTable
      },
      addRow () {
        const Model = () => ({
          name: '',
          unit: '',
          count: ''
        })
        this.$refs.editTable.createRow(new Model())
      }
    }
  }
</script>
